module.exports = __webpack_public_path__ + "static/img-about@3x-6920f5ec8b239184a836fa94cebe21dd.png";